import mxins from '../mixins';
import { mapMutations } from 'vuex';

import { gsap } from 'gsap';
import { each } from 'lodash-es';

export default {
  mixins  : [mxins],
  computed: {},
  mounted() {
    this.setIsMain(false);
    console.log('!!!!! $route :', this.$route);

    if (this.device === 'pc') {
      this.setHeaderOpen(false);
      this.setHeaderFamily(false);
    }
  },
  methods: {
    ...mapMutations('main', {
      setIsMain: 'SET_IS'
    }),
    ...mapMutations('view', {
      setHeaderOpen  : 'SET_HEADER_OPEN',
      setHeaderFamily: 'SET_HEADER_FAMILY'
    }),
    async initTween(idx = '') {
      if (this.device === 'mo') {
        return;
      }

      const y = document.querySelectorAll(`.gs_y${idx}`);
      const st = document.querySelectorAll(`.gs_st${idx}`);
      const zoom = document.querySelectorAll(`.gs_zoom${idx}`);

      each(y, (item) => {
        gsap.set(item, {
          transform: 'translateY(6rem)',
          alpha    : 0
        });
      });

      each(st, (item) => {
        gsap.set(item.children, {
          transform: 'translateY(5rem)',
          alpha    : 0
        });
      });

      each(zoom, (item) => {
        gsap.set(item, {
          transform: 'scale(1.2)'
        });
      });

      await gsap.delayedCall(0.3);

      each(y, (item) => {
        gsap.to(item, {
          scrollTrigger: {
            start  : 'top 80%',
            trigger: item
          },
          transform: 'translateY(0rem)',
          duration : 1.2,
          alpha    : 1
        });
      });

      each(st, (item) => {
        gsap.to(item.children, {
          scrollTrigger: {
            target : item,
            start  : 'top 80%',
            trigger: item
          },
          duration : 0.7,
          delay    : 0.3,
          stagger  : 0.2,
          transform: 'translateY(0rem)',
          alpha    : 1
        });
      });

      each(zoom, (item) => {
        gsap.to(item, {
          scrollTrigger: {
            start  : 'top 60%',
            trigger: zoom
          },
          duration : 2,
          transform: 'scale(1)'
        });
      });
    }
  }
};
